import { AuthConfig } from '~auth/providers/auth.provider';

export { AuthProvider, RequestOptions, Authenticator, AUTH_PROVIDERS, AUTH_CONFIG, AuthConfig } from './auth.provider';
export { CookieProvider } from './cookie.provider';
export { TokenProvider, STORAGE } from './token.provider';

export { AoCookieProvider } from './ao-cookie.provider';
export { DacTokenProvider } from './dac-token.provider';



// WEBPACK FOOTER //
// ./src/app/auth/providers/index.ts